module.exports = __webpack_public_path__ + "static/media/fb.745240d0.svg";